<svelte:options accessors={true}/>
<script>
	import InsightMetricsBuilder from './../../components/InsightMetricsBuilder.svelte';
    import {onMount} from 'svelte';
    import ReportsService from "../../services/reports.service";
    import Loader from "../../components/Loader.svelte";
    import EditableCell from "../../components/EditableCell.svelte";
    import AuthService from '../../services/auth.service.js';
    import {formatValue, replaceUnderScore} from '../../helpers/format.helper';
    import {getMonthlyClass, getActualClass, stylesList, metricList, metricOptions, getPastDateData, getQuarterlyStyle} from '../../helpers/style.helper';
    import ColorPicker from "../../components/ColorPicker.svelte";
    import ExportService from "../../services/export.service";

    export let user, params, loadingExport = false;

    let sections,
        kpiToChange,
        errorMessage,
        disableButton = false,
        disableSaveButton = false,
        dropped = [],
        deletedItems = [],
        dropped_in = '',
        sectionName = '',
        loading = true,
        deleteConfirmation = false,
        currentKPI = {},
        currentSection = {},
        sectionToChange = {},
        selectedSection = null,
        headers = [],
        sectionDragged,
        showMetrics,
        defaultKpis;

    const formatTitles = [
        'Numeric', 'Currency ($)', 'Percentage (%)', 'Days', 'Multiplier (x)', 'B.P.S. (bps)'
    ];

    const MAX_KPIS = 8;

    const formulasTitles = {
        'SUM': 'Summation',
        'AVG': 'Average',
        'LMQ': 'Last Month of Quarter'
    };

    $: loadData(params);

    onMount(() => {
        cleanKPI();
        loadData();
        getDefaultKpis();
    });

    function month() {
        if (params.subMenu == 'summary') {
            return '/' + params.month;
        } else {
            return '';
        }
    }

    export async function loadData() {
        showMetrics = false;
        loading = true;
        selectedSection = null;
        const url = '/org/' + params.org + '/monthly/' + params.subMenu + '/date/' + params.year + month();
        let result = null;
        sections = null;
        try {
            result = await ReportsService.load(url);
            //Scroll to previous position
            setTimeout(() => {
                var scrolled = (localStorage.getItem('scrolled'))? localStorage.getItem('scrolled') : 0;
                jQuery('#reportsDiv').scrollTop(scrolled);
                localStorage.setItem("scrolled",0);
            }, 500);
        } catch (e) {
            sections = null;
            console.log('Error', e);
        }

        if (result && result.data){
            sections = result.data.sections;
            headers = result.data.headers;
        }
        if(new Date().getFullYear() == params.year || params.subMenu == "summary") showMetrics = true;
        loading = false;

        setTimeout(() => {
            jQuery('.sticky-thead').removeClass('d-none');
            tablesLoaded();
            enableTableSelection();
        }, 1000);
    }

    let getDefaultKpis = async function() {
        let kpisResult = null;
        try {
            kpisResult = await ReportsService.load('/kpis/default');
            if (kpisResult && kpisResult.data) defaultKpis = kpisResult.data;
            console.log('kpis: ', defaultKpis);
        } catch (e) {
            console.log('Error', e);
        }
    }

    let selectDefaultKpi = function (kpiIndex) {
        const kpi = defaultKpis[kpiIndex];
        currentKPI.title = kpi.title;
        currentKPI.format = kpi.format;
        currentKPI.formula_id = kpi.formula_id;
        currentKPI.taxonomy = kpi.taxonomy;
    }

    let saveKPIData = async function(value, kpi_id, date, actual, budget, valueType, elementId, kpi) {
        let body;
        if(valueType == 'actual'){
            body = { kpi_id, date: params.year + '-' + date + "-01", actual, locked: false, notes: 'none' };
        }else{
            body = { kpi_id, date: params.year + '-' + date + "-01", budget, locked: false, notes: 'none' };
        }
        // Update insight metrics data
        if(kpi.insight_metric_data && kpi.insight_metric_data.data && kpi.insight_metric_data.data[date]){
            kpi.insight_metric_data.data[date][valueType] = value;
            let totalActual = 0, totalBudget = 0, percentage ;
            Object.keys(kpi.insight_metric_data.data).map( kpiData => {
                totalActual += parseFloat(kpi.insight_metric_data.data[kpiData].actual);
                totalBudget += parseFloat(kpi.insight_metric_data.data[kpiData].budget);
            });
            const metric = JSON.parse(kpi.metric);
            let message = "";
            const amount = parseFloat(metric.amount);
            const ruleMessage = amount + " " + metricOptions.formats[metric.format] + " " +
              metricOptions.conditions[metric.condition] + " " + metricOptions.periods[metric.period];
            switch(metric.condition){
                case 0:
                    percentage = (totalBudget * amount) / 100;
                    if ((!kpi.inverted && totalActual <= totalBudget - percentage) || (kpi.inverted && totalActual >= totalBudget + percentage)) {
                        message = ruleMessage;
                    }
                    break;
                case 1:
                    if ((!kpi.inverted && totalActual <= totalBudget - amount) || (kpi.inverted && totalActual >= totalBudget + amount)) {
                        message = ruleMessage;
                    }
                    break;
                case 2:
                    if(totalActual - totalBudget >= amount){
                        message = ruleMessage;
                    }
                    break;
            }
            kpi.insight_metric_data.message = message;
        }else{
            console.log(kpi.insight_metric_data.data, date);
        }
        await ReportsService.saveKpiData(body);
        jQuery('#'+elementId).addClass('manual-data-kpi') 
    }

    let onSaveKPI = async function () {
        disableSaveButton = true;
        errorMessage = null;

        try {
            if (currentKPI.id) {
                if (JSON.stringify(currentKPI) != JSON.stringify(kpiToChange)) {
                    await ReportsService.updateKpi(currentKPI);
                    loadData();
                }
            } else {
                await ReportsService.saveKpi(currentKPI);
                loadData();
            }

            disableSaveButton = false;
            jQuery('#addKPI').modal('hide');
            cleanKPI();
        } catch (e) {
            errorMessage = e.message;
        }
    }

    let onSaveSection = async function() {
        disableSaveButton = true;
        errorMessage = null;
        let response = null;

        try {
            if(currentSection.id){
                if(JSON.stringify(sectionToChange) != JSON.stringify(currentSection)){
                    await ReportsService.updateSection(currentSection);
                    loadData();
                }
            }else{
                await ReportsService.saveSection(currentSection);
                loadData();
            }
            disableSaveButton = false;
            jQuery('#editSection').modal('hide');
            currentSection = {}; //"Clean" it
        } catch (e) {
            errorMessage = e.message;
        }
    }

    let onDeleteKPI = async function () {
        disableButton = true;
        errorMessage = null;

        try {
            await ReportsService.deleteKpi(currentKPI.id);
            jQuery('#addKPI').modal('hide');
            cleanKPI();
            loadData();
        } catch (e) {
            errorMessage = e.message;
        }
    }

    let setDeleteConfirmation = function () {
        deleteConfirmation = true;
        setTimeout(() => {
            if (deleteConfirmation) deleteConfirmation = false;
        }, 3000);
    }

    function cleanKPI() {
        currentKPI = {
            type: '1', // monthly
            title: '',
            taxonomy: '',
            format: 0,
            section_id: null,
            notes: '',
            taxonomy_notes: '',
            style: '',
            locked: 0,
            metric: '',
            inverted: false
        };
    }

    function cleanSection() {
        currentSection = {
            title: "",
            type: '1',
            organization_id: params.org
        };
    }

    function fillKPI(section) {
        cleanKPI();
        jQuery('#kpi-tab').click();
        currentKPI.op_section_id = section.id;
        sectionName = section.title;
        jQuery('#addKPI').modal('show');
    }

    function editKPI(e, kpi) {
        cleanKPI();
        deleteConfirmation = false;
        disableButton = false;
        jQuery('#kpi-tab').click();
        currentKPI = kpi;
        kpiToChange = {...currentKPI};
        jQuery('#addKPI').modal('show');
    }

    function switchKPILock() {
        currentKPI.locked = currentKPI.locked === 1 ? 0 : 1;
    }

    let showUnlockTooltip = function() {
        jQuery('#btnLock').tooltip('show');
        setTimeout(() => {
            jQuery('#btnLock').tooltip('hide');
        }, 5000);
    }

    async function handleDrop(e, section_id, position) {
        e.preventDefault();
        var id = e.dataTransfer.getData("text");
        try {
            await ReportsService.updateKpiPosition({id, type: 1, section_id, position});
            loadData();
        } catch (e) {
            console.log(e);
        }
    }

    function handleDragStart(e, id, sectionId) {
        sectionDragged = sectionId;
        e.dataTransfer.dropEffect = "move";
        e.dataTransfer.setData("text", id);
    }

    function handleDragEnter(e) {
        e.dataTransfer.dropEffect = "move";
        window.jQuery(e.target).css('border-top', '2px dashed #fdc59b');
        window.jQuery(e.target).css('box-shadow', 'inset 0 0 10px #fdc59b');
    }

    function handleDragLeave(e) {
        console.log(e.target);
        window.jQuery(e.target).css('border-top', '1px solid #dee2e6');
        window.jQuery(e.target).css('box-shadow', 'none');
    }

    function editSection(section){
        currentSection = section;
        deleteConfirmation = false;
        disableButton = false;
        console.log(currentSection);
        sectionToChange = { ...currentSection }; //Used to verify if at least a field change
        jQuery('#editSection').modal('show');
    }

    export function addSection(){
        cleanSection();
        jQuery('#editSection').modal('show');
    }

   export async function exportToExcel() {
        const urlToExport = '/org/' + params.org + '/export/monthly/date/' + params.year;
        let result = null;
        loadingExport = true;

        try {
            result = await ReportsService.load(urlToExport);
            if (result && result.data){
                await ExportService.downloadKpi(result.data.sections, user.name, 'monthly-' + jQuery('#dropdownOrganizations').text() + "-" + params.year, true, result.data.headers);
            } else {
                console.log('No sections found');
            }
        } catch (e) {
            console.log('Error', e);
        }

        loadingExport = false;
    }

    function getDate(date) {
        let months = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];

        return months.indexOf(date).toString().padStart(2, '0') + '/01/' + params.year;
    }


    let onDeleteSection = async function() {
        disableButton = true;
        errorMessage = null;

        try {
            await ReportsService.deleteSection(currentSection.id);
            jQuery('#editSection').modal('hide');
            deleteConfirmation = false;
            loadData();
        } catch (e) {
            errorMessage = e.message;
        }
    }

    async function changeSectionPosition(sectionId, newPosition){
        if(selectedSection != sectionId){
            try {
                await ReportsService.updateSectionPosition({id: selectedSection, position: newPosition});
                loadData();
            } catch (e) {
                console.log(e);
            }
        }
        selectedSection = null;
    }

    function onSelectSection(sectionId){
        selectedSection = sectionId;
        jQuery('.sticky-thead').addClass('d-none');
    }

    jQuery(function() {
        jQuery('#toggle-event').change(function() {
            jQuery('#console-event').html('Toggle: ' + jQuery(this).prop('checked'))
        })
        console.log("changed");
    })
</script>
<button class="d-none" id="reloadData" on:click={loadData}>RELOAD</button>

<div class="modal fade" id="restoreSection" tabindex="-1" role="dialog" aria-labelledby="restoreSectionLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="restoreSectionLabel">
                    Restore Sections
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="alert alert-info">
                    Review these deleted items, and click the
                    <button class="btn btn-sm py-0 btn-outline-primary" disabled>
                        <i class="fa fa-undo"></i>
                    </button> RESTORE button to undelete that item.
                </div>
                <table class="table table-md">
                    <tr class="font-weight-bold text-uppercase">
                        <th><small>Section</small></th>
                        <th class="text-center"><small>Deleted</small></th>
                        <th class="text-right"><small>Restore</small></th>
                    </tr>
                    {#each deletedItems as section}
                        <tr>
                            <td class="p-1">
                                <small><strong>
                                    {section.id} - {section.title}
                                </strong></small>
                            </td>
                            <td class="text-center p-1">
                                <small>{section.deleted_at.split('T')[0]}</small>
                            </td>
                            <td class="text-right p-1">
                                <button class="btn btn-sm py-0 btn-outline-primary" on:click={restoreItem(section.id)}>
                                    <i class="fa fa-undo"></i>
                                </button>
                            </td>
                        </tr>
                    {/each}
                </table>
            </div>
            {#if errorMessage}
                <div class="alert alert-danger">
                    ERROR: {errorMessage}
                </div>
            {/if}
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="addKPI" tabindex="-1" role="dialog" aria-labelledby="addKPILabel" aria-hidden="true">
    <div class="modal-dialog modal-650">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="addKPILabel">
                    {#if currentKPI.id}
                        Edit KPI

                        {#if AuthService.can('UNLOCK_KPI') }
                            <button id="btnLock" class="btn btn-sm ml-auto" on:click={switchKPILock} data-toggle="tooltip" data-placement="right" title="Click here to unlock">
                                {#if currentKPI.locked === 1}
                                    <span class="fa fa-lock"></span>
                                {:else}
                                    <span class="fa fa-unlock text-warning"></span>
                                {/if}
                            </button>
                        {/if}
                    {:else}
                        <span class="text-muted">Add New KPI to</span>
                        <em class="text-dark bg-warning px-1">{sectionName}</em>
                    {/if}
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                {#if AuthService.can('ANNOTATE_KPI') && currentKPI.id }
                    <ul class="nav nav-tabs mb-3" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="kpi-tab"
                               data-toggle="tab" href="#kpi" role="tab" aria-controls="kpi" aria-selected="true">
                                KPI
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="notes-tab"
                               data-toggle="tab" href="#notes" role="tab" aria-controls="notes" aria-selected="false">
                                Notes
                            </a>
                        </li>
                        {#if params.subMenu == 'summary' || params.subMenu == 'ya_vs_budget'}
                            <li class="nav-item">
                                <a class="nav-link" id="style-tab"
                                   data-toggle="tab" href="#style" role="tab" aria-controls="style" aria-selected="false">
                                    Conditional Formatting
                                </a>
                            </li>
                        {/if}
                        {#if params.subMenu == 'quarterly'}
                            <li class="nav-item">
                                <a class="nav-link" id="formula-tab"
                                   data-toggle="tab" href="#formula" role="tab" aria-controls="formula" aria-selected="false">
                                    Quarterly Formula
                                </a>
                            </li>
                        {/if}
                    </ul>
                {/if}
                {#if currentKPI.id}
                <form>
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="kpi" role="tabpanel" aria-labelledby="kpi-tab">
                        {#if currentKPI.id}
                            <div class="form-group">
                                <p><b>KPI ID:</b> {currentKPI.id} </p>
                            </div>
                        {/if}
                        <div class="form-group">
                            <label for="nameInput">Title</label>
                            <input bind:value={currentKPI.title} type="text" maxlength="64" class="form-control" id="nameInput" placeholder="Title">
                        </div>
                        <div class="form-group">
                            <label for="taxonmyInput">Taxonomy & Definitions</label>
                            <textarea bind:value={currentKPI.taxonomy} maxlength="128" class="form-control" id="taxonmyInput" placeholder="Taxonomy and Definitions"></textarea>
                        </div>
                        <div class="form-group">
                            <label for="formatInput">Format:</label>
                            <select bind:value={currentKPI.format} class="form-control" id="formatInput">
                                {#each formatTitles as name, id}
                                    <option value={id}>{name}</option>
                                {/each}
                            </select>
                        </div>
                        <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="inverted" bind:checked={currentKPI.inverted}>
                            <label class="form-check-label" for="inverted">Inverted Values</label>
                        </div>
                    </div>
                    {#if AuthService.can('ANNOTATE_KPI') }
                        <div class="tab-pane fade" id="notes" role="tabpanel" aria-labelledby="notes-tab">
                            <div class="form-group">
                                <label for="notesInput">KPI</label>
                                <textarea bind:value={currentKPI.notes} type="text" rows="4"
                                          class="form-control" id="notesInput" placeholder="Notes"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="taxonomy_notesInput">Taxonomy & Definitions</label>
                                <textarea bind:value={currentKPI.taxonomy_notes} type="text" rows="4"
                                          class="form-control" id="taxonomy_notesInput" placeholder="Taxonomy Notes"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="commentsInput">Comments</label>
                                <textarea bind:value={currentKPI.comments} type="text" rows="4"
                                          class="form-control" id="commentsInput" placeholder="This will be shown in the last column"></textarea>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="style" role="tabpanel" aria-labelledby="style-tab">
                            <div class="form-group">
                                <label>
                                    <input type=radio name="customStyle"
                                        checked="{ !currentKPI.style || currentKPI.style.length == 0 }" on:click={() => currentKPI.style=''}>
                                    Default
                                </label>
                                <label class="ml-3">
                                    <input type=radio name="customStyle"
                                        checked="{ currentKPI.style && currentKPI.style.length > 0 }" on:click={() => currentKPI.style=stylesList[1].code }>
                                    Custom
                                </label>
                            </div>
                            {#if currentKPI.style && currentKPI.style.length > 0 }
                                <ColorPicker bind:value={currentKPI.style} bind:inverted={currentKPI.inverted}></ColorPicker>
                            {/if}
                        </div>
                        <div class="tab-pane fade" id="formula" role="tabpanel" aria-labelledby="formula-tab">
                            <div class="form-group">
                                <label for="formulaInput">Calculate the Quarterly Formula using: </label>
                                <select bind:value={currentKPI.formula} class="form-control" id="formulaInput">
                                    {#each Object.keys(formulasTitles) as id}
                                        <option value={id}>{formulasTitles[id]}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="insight_metrics" role="tabpanel" aria-labelledby="style-tab">
                            <div class="form-group">
                                <!-- <input type="checkbox" data-toggle="toggle" data-on="Enabled" data-off="Disabled"> -->

                                <label>
                                    <input type=radio name="customMetric"
                                        checked="{ !currentKPI.metric || currentKPI.metric.length == 0 }" on:click={() => currentKPI.metric=''}>
                                    Disabled
                                </label>
                                <label class="ml-3">
                                    <input type=radio name="customMetric"
                                        checked="{ currentKPI.metric && currentKPI.metric.length > 0 }" on:click={() => currentKPI.metric = metricList.monthly}>
                                    Enabled
                                </label>
                            </div>
                            {#if currentKPI.metric && currentKPI.metric.length > 0 && AuthService.can('EDIT_INSIGHT_METRICS')}
                                <InsightMetricsBuilder bind:value={currentKPI.metric} reportType='monthly'></InsightMetricsBuilder>
                            {/if}
                        </div>
                    {/if}
                </div>
            </form>
                {:else if defaultKpis}
                    <div class="form-group">
                        <select on:change="{(e) => selectDefaultKpi(e.target.value)}" class="form-control" id="formatInput">
                            {#each defaultKpis as kpi, kpiIndex}
                                <option value="{kpiIndex}">{kpi.title}</option>
                            {/each}
                        </select>
                    </div>
                {/if}
            </div>
            {#if errorMessage}
                <div class="alert alert-danger">
                    ERROR: {errorMessage}
                </div>
            {/if}
            <div class="modal-footer">
                {#if AuthService.can('DELETE_KPI') }
                    {#if currentKPI.id}
                        {#if currentKPI.locked}
                             <button type="button" class="btn btn-danger mr-auto disabled" on:click={showUnlockTooltip}>
                                <i class="fa fa-lock mr-2"></i> DELETE
                            </button>
                         {:else if deleteConfirmation}
                            <button type="button" class="btn btn-danger mr-auto" on:click={onDeleteKPI} disabled={disableButton}>
                                Click to confirm
                            </button>
                        {:else}
                            <button type="button" class="btn btn-danger mr-auto" on:click={setDeleteConfirmation}>
                                DELETE
                            </button>
                        {/if}
                    {/if}
                {/if}

                <button type="button" class="btn btn-secondary" data-dismiss="modal" on:click={cleanKPI}>Close</button>

                <button type="button" class="btn btn-success" on:click={onSaveKPI} disabled={disableSaveButton}>
                    {#if currentKPI.id}
                        Update
                    {:else}
                        Save
                    {/if}
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="editSection" tabindex="-1" role="dialog" aria-labelledby="editTeam" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="editTeamLabel">
                    {#if currentSection.id}
                        Edit
                    {:else}
                        Add
                    {/if} section
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">

                {#if AuthService.can('EDIT_TEAM') }
                    <label for="teamName">Name:</label>
                    <input bind:value={currentSection.title} maxlength="64" type="text" class="form-control" id="sectionName" placeholder="Section Name">
                    {#if !currentSection.title}
                        <small class="text-danger ml-2 font-weight-bold">Name is required</small>
                    {/if}
                {/if}
            </div>
            <div class="modal-footer text-right">
                {#if AuthService.can('DELETE_SECTION') }
                    {#if currentSection.id}
                        {#if deleteConfirmation}
                            <button type="button" class="btn btn-danger mr-auto" on:click={onDeleteSection} disabled={disableButton}>
                                Click to confirm
                            </button>
                        {:else}
                            <button type="button" class="btn btn-danger mr-auto" on:click={setDeleteConfirmation}>
                                DELETE
                            </button>
                        {/if}
                    {/if}
                {/if}

                <button type="button" class="btn btn-secondary" data-dismiss="modal" >Cancel</button>
                {#if currentSection.title}
                    <button type="button" class="btn btn-success " on:click={onSaveSection} disabled={disableSaveButton}>
                        {#if currentSection.id}
                            Update
                        {:else}
                            Save
                        {/if}
                    </button>
                {:else}
                    <button type="button" class="btn btn-danger disabled" disabled={disableSaveButton}>
                        {#if currentSection.id}
                            Update
                        {:else}
                            Save
                        {/if}
                    </button>
                {/if}
            </div>
        </div>
    </div>
</div>

{#if loading}
    <Loader fixed={true}></Loader>
{/if}

{#if !sections}
    <h4 class="text-danger text-center">...</h4>
{:else}
    <div id="popover-notes" class="comment-popover d-none" ></div>
    <div id="popover-comments" class="comment-popover d-none" >
        <div id="close-comments" class="text-right text-primary pointer h6 font-weight-bold">X</div>
        <div id="comments-body"></div>
    </div>
    <div id="popover-metric" class="alert alert-danger d-none" ></div>
    {#each sections as section, sectionIndex }
        {#if section.position !== null}
            {#if selectedSection}
                <div class="move-here"
                    on:click={ changeSectionPosition(section.id, section.position) }>
                    Move here
                </div>
            {/if}
            <div class="table-wrapper { selectedSection && selectedSection == section.id ? 'selectedSection' : ''}">
                <table class="table table-sm container-fluid table-monthly selectable-table">
                    <thead>
                        <tr class="{section.position !== null? 'bg-dark': 'bg-danger'} text-light">
                            <th class="{section.position !== null? 'col-header': 'bg-danger'}">
                                {section.title}
                                {#if AuthService.can('EDIT_SECTION') }
                                    <i on:click={ () =>  editSection(section)}
                                        class="fa fa-pencil-square-o text-light float-right btn btn-sm px-0"></i>
                                    {#if !selectedSection}
                                        <i 
                                            class="fa fa-arrows pointer mr-1 mt-1 float-right"
                                            on:click={ onSelectSection(section.id)}
                                        ></i>
                                    {/if}
                                {/if}
                            </th>
                            {#if params.subMenu == 'summary'}
                                <th class="col-subheader">Taxonomy & Def.</th>
                            {/if}
                            {#if params.subMenu == 'ya_vs_budget' || params.subMenu == 'ya_vs_py' || params.subMenu == 'quarterly'}
                                <th class="col-info weekly-type">Type</th>
                            {/if}

                            {#each headers as id}
                                <th class="notFixed">{replaceUnderScore(id)}</th>
                            {/each}
                            <th class="col-comments notFixed">Comments</th>
                        </tr>
                    </thead>
                    <tbody>
                    {#each section.kpis as kpi, kpiIndex}
                        <tr>
                            <th class="col-header rowDropArea {(kpi.insight_metric_data.message && showMetrics) ? 'alert alert-danger' : ''}"
                                draggable="true"
                                ondragover="return false"
                                on:dragstart={(e) => handleDragStart(e, kpi.id, section.id) }
                                on:dragenter={(e) => (sectionDragged == section.id? handleDragEnter(e): true)}
                                on:dragleave={(e) => (sectionDragged == section.id? handleDragLeave(e): true)}
                                on:drop={(e) => (sectionDragged == section.id? handleDrop(e, section.id, kpiIndex): true) }>
                                {#if kpi.notes && kpi.notes.length > 0}
                                    <i data-notes="{kpi.notes}"
                                    class="fa fa-sticky-note-o fa-corner-icon float-right btn btn-sm px-0 action-comment"></i>
                                {/if}
                                {#if AuthService.can('EDIT_KPI') }
                                    {#if kpi.locked === 1}
                                        {#if AuthService.can('UNLOCK_KPI') }
                                            <i data-id="{kpi.id}"
                                            on:click={ (e) => editKPI(e, kpi) }
                                            class="fa fa-pencil-square-o text-primary float-right btn btn-sm px-0 ml-1 action-edit"></i>
                                        {/if}
                                        <span class="fa fa-lock text-warning float-right btn btn-sm px-0 not-allowed"></span>
                                    {:else}
                                        <i data-id="{kpi.id}"
                                        on:click={ (e) => editKPI(e, kpi) }
                                        class="fa fa-pencil-square-o text-primary float-right btn btn-sm px-0 ml-1 action-edit"></i>
                                    {/if}
                                {/if}
                                <i data-message={kpi.insight_metric_data.message}
                                    class="fa fa-warning text-danger float-right btn btn-sm px-0 mr-1 action-metric {(kpi.insight_metric_data.message && showMetrics) ? '' : 'd-none'}">
                                </i>
                                {kpi.title}
                            </th>
                            {#if params.subMenu == 'summary'}
                                <td class="col-subheader">
                                    {#if kpi.taxonomy_notes && kpi.taxonomy_notes.length > 0}
                                        <i data-notes="{kpi.taxonomy_notes}"
                                        class="fa fa-sticky-note-o fa-corner-icon action-comment"></i>
                                    {/if}
                                    {kpi.taxonomy || ''}
                                </td>
                            {/if}
                            {#if params.subMenu == 'ya_vs_budget'}
                                <td class="col-info"><small>Actual<hr>Budget</small></td>
                            {:else if params.subMenu == 'ya_vs_py'}
                                <td class="col-info"><small>Actual<hr>Prior year</small></td>
                            {:else if params.subMenu == 'quarterly'}
                                <td class="col-info"><small>Actual<hr>Budget<hr>Prior year</small></td>
                            {/if}
                            {#each Object.keys(kpi.kpiData) as id, kpiDataIndex}
                                {#if params.subMenu == 'summary'}
                                    {#if id == 'month_vs_budget' || id == 'month_vs_py' }
                                        <td class="readOnly notFixed { getMonthlyClass(kpi.style, kpi.kpiData[id], params.subMenu) }">
                                            {formatValue(kpi.format, kpi.kpiData[id], params.subMenu)}
                                        </td>
                                    {:else}
                                        <td class="readOnly">
                                            {formatValue(kpi.format, kpi.kpiData[id], params.subMenu)}
                                        </td>
                                    {/if}

                                {:else if params.subMenu == 'ya_vs_budget' && kpi.kpiData[id] && typeof kpi.kpiData[id] === 'object'}
                                    <td class="{ AuthService.can('EDIT_KPI')? 'notFixed': 'readOnly'} ">
                                        {#if AuthService.can('EDIT_CELL') }
                                            <EditableCell
                                                customClass="{ getActualClass(kpi.style, kpi.kpiData[id], 'monthly', id, params.year, kpi.inverted)} {(!kpi.kpiData[id].actual_imported)?'manual-data-kpi':''}"
                                                id="t{sectionIndex}-{kpiIndex*2}-{kpiDataIndex}"
                                                xdata="{ {id: kpi.id, report: 'monthly', date: getDate(id), field: "actual", value: kpi.kpiData[id].actual } }"
                                                on:change={(e) => saveKPIData(e.detail.value, kpi.id, id, kpi.kpiData[id].actual, kpi.kpiData[id].budget, 'actual' , `t${sectionIndex}-${kpiIndex*2}-${kpiDataIndex}`, kpi)}
                                                bind:value={kpi.kpiData[id].actual}
                                                format={kpi.format}></EditableCell>
                                            <hr>
                                            <EditableCell
                                                customClass="{(!kpi.kpiData[id].budget_imported)?'manual-data-kpi':''} {(kpi.kpiData[id].actual && kpi.kpiData[id].budget == 0) ? 'style-red' : '' } {getPastDateData(kpi.kpiData[id].budget, id+"/"+params.year , 'monthly')}"
                                                id="t{sectionIndex}-{(kpiIndex*2) + 1}-{kpiDataIndex}"
                                                xdata="{ {id: kpi.id, report: 'monthly', date: getDate(id), field: "budget", value: kpi.kpiData[id].budget } }"
                                                on:change={(e) => saveKPIData(e.detail.value, kpi.id, id, kpi.kpiData[id].actual, kpi.kpiData[id].budget, 'budget', `t${sectionIndex}-${(kpiIndex*2) + 1}-${kpiDataIndex}`, kpi)}
                                                bind:value={kpi.kpiData[id].budget}
                                                format={kpi.format}></EditableCell>
                                        {:else}
                                            <div id="t{sectionIndex}-{kpiIndex*2}-{kpiDataIndex}">
                                                { formatValue(kpi.format, kpi.kpiData[id].actual) }
                                            </div>
                                            <hr>
                                            <div id="t{sectionIndex}-{(kpiIndex*2) + 1}-{kpiDataIndex}">
                                                { formatValue(kpi.format, kpi.kpiData[id].budget) }
                                            </div>
                                        {/if}
                                    </td>
                                {:else if params.subMenu == 'ya_vs_py' && kpi.kpiData[id] && typeof kpi.kpiData[id] === 'object'}
                                    <td class="readOnly">
                                        <div id="t{sectionIndex}-{kpiIndex*2}-{kpiDataIndex}">
                                            { formatValue(kpi.format, kpi.kpiData[id].actual) }
                                        </div>
                                        <hr>
                                        <div id="t{sectionIndex}-{(kpiIndex*2) + 1}-{kpiDataIndex}">
                                            { formatValue(kpi.format, kpi.kpiData[id].py) }
                                        </div>
                                    </td>
                                {:else if params.subMenu == 'quarterly'}
                                    <td class="readOnly">
                                        <div class="{getQuarterlyStyle(kpi.style, kpi.formula, kpi.kpiData[id].actual, kpi.kpiData[id].budget)}">
                                            { formatValue(kpi.format, kpi.kpiData[id].actual) }
                                        </div>
                                        <div class="{(kpi.kpiData[id].actual && kpi.kpiData[id].budget == 0)?'style-red':''} {getPastDateData(kpi.kpiData[id].budget, id , 'quarterly', params.year)}">
                                            { formatValue(kpi.format, kpi.kpiData[id].budget) }
                                        </div>
                                        <div>
                                            { formatValue(kpi.format, kpi.kpiData[id].prior_year) }
                                        </div>
                                    </td>
                                {:else}
                                    <td class="readOnly notFixed">
                                        {formatValue(kpi.format, kpi.kpiData[id], params.subMenu)}
                                    </td>
                                {/if}
                            {/each}
                            <td class="col-comments notFixed readOnly">
                                <span data-comments="{kpi.comments || ''}" class="text-primary comments-truncate monthly pointer full-comments">
                                    {kpi.comments || ''}
                                </span>
                            </td>
                        </tr>
                    {:else}
                        <tr>
                            <th class="col-header">
                                ---
                            </th>
                            {#if params.subMenu == "summary"}
                                <td class="col-subheader">---</td>
                            {:else}
                                <td class="col-info"><small>---</small></td>
                            {/if}
                            {#each headers as header}
                                <td class="notFixed readOnly text-light">&emsp; </td>
                            {/each}
                        </tr>
                    {/each}
                        <tr class="border-0">
                            <th class="bg-transparent col-header">
                                {#if section.position !== null && AuthService.can('ADD_KPI') && section.kpis.length < MAX_KPIS}
                                    <button class="mt-2 btn btn-primary btn-sm text-light float-left"
                                            data-id="{section.id}"
                                            on:click|preventDefault={(e) => fillKPI(section)}>
                                        <i class="fa fa-plus"></i>
                                        Add KPI
                                    </button>
                                {/if}
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>
        {/if}
    {/each}
{/if}

<style>
    .col-subheader {
        white-space: pre;
    }
</style>